export var PriceType;
(function (PriceType) {
    PriceType["PER_RESOURCE"] = "PER_RESOURCE";
    PriceType["FLAT_RATE"] = "FLAT_RATE";
})(PriceType || (PriceType = {}));
